import { render } from "./MisCotizaciones.vue?vue&type=template&id=bb46a6ee&scoped=true"
import script from "./MisCotizaciones.vue?vue&type=script&lang=js"
export * from "./MisCotizaciones.vue?vue&type=script&lang=js"

import "./MisCotizaciones.vue?vue&type=style&index=0&id=bb46a6ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb46a6ee"]])

export default __exports__